/* unplugin-vue-components disabled */import script from "./SpaceInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./SpaceInfo.vue?vue&type=script&setup=true&lang=js"

import "./SpaceInfo.vue?vue&type=style&index=0&id=655e02a3&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-655e02a3"]])

export default __exports__